/**
 * TokenManager provides a bridge between React hooks (useAuth0) and non-React code
 * (like Axios interceptors) for accessing Auth0 access tokens without storing them
 * in localStorage.
 */
export class TokenManager {
    private static instance: TokenManager | null = null;
    private getAccessTokenSilently: (() => Promise<string>) | null = null;

    private constructor() {}

    static getInstance(): TokenManager {
        if (!TokenManager.instance) {
            TokenManager.instance = new TokenManager();
        }
        return TokenManager.instance;
    }

    initialize(getAccessTokenSilently: () => Promise<string>): void {
        this.getAccessTokenSilently = getAccessTokenSilently;
    }

    async getToken(): Promise<string | null> {
        if (!this.getAccessTokenSilently) {
            return null;
        }

        try {
            return await this.getAccessTokenSilently();
        } catch {
            return null;
        }
    }

    clear(): void {
        this.getAccessTokenSilently = null;
    }
}
